// src/components/enduser/calculators/PersonalImportCalculatorsPage.tsx

import React from "react";
import { Link } from "react-router-dom";
import { useMotionSafe } from "../../../hooks/useMotionSafe";
import CollectorCarIcon from "../../../assets/icons/collector-car.svg";
import N1ElectricPickupIcon from "../../../assets/icons/n1-electric-pickup.svg";
import M1ElectricCarIcon from "../../../assets/icons/m1-electric-car.svg";
import N1TenderPickupIcon from "../../../assets/icons/n1-tender-pickup.svg";
import M1PetrolDieselCarIcon from "../../../assets/icons/m1-petrol-diesel-car.svg";
import MotorcycleIcon from "../../../assets/icons/motorcycle.svg";
import JetSkiIcon from "../../../assets/icons/jet-ski.svg";
import TaxiIcon from '../../../assets/icons/taxi.svg';


interface Calculator {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  category: string;
  route: string;
}

const PersonalImportCalculatorsPage: React.FC = () => {
  // השימוש ב-hook החדש
  const { shouldAnimate, getAnimationClass, getHoverClass } = useMotionSafe();

  const calculators: Calculator[] = [
    {
      id: "m1-petrol-diesel",
      title: "רכב פרטיM1  מונע במנוע בנזין, דיזל, היברידי, פלאג אין",
      description:
        "חישוב מיסים עבור רכב נוסעים רגיל מקבוצת M1 המיובא באופן אישי",
      // icon: (
      //   <svg
      //     className="w-8 h-8 text-blue-600"
      //     fill="none"
      //     stroke="currentColor"
      //     viewBox="0 0 100 100"
      //     strokeWidth="2.5"
      //   >
      //     <path
      //       d="M20 60 L20 55 L25 45 L35 35 L65 35 L75 45 L80 55 L80 60"
      //       strokeLinejoin="round"
      //     />
      //     <path d="M30 45 L35 35 L65 35 L70 45" strokeLinejoin="round" />
      //     <line x1="50" y1="35" x2="50" y2="45" />
      //     <circle cx="30" cy="60" r="6" strokeWidth="2.5" />
      //     <circle cx="70" cy="60" r="6" strokeWidth="2.5" />
      //     <line x1="15" y1="60" x2="85" y2="60" strokeWidth="3" />
      //   </svg>
      // ),
      icon: (
        <img
          src={M1PetrolDieselCarIcon}
          alt="רכב M1 בנזין/דיזל"
          className="w-12 h-12 object-contain"
        />
      ),
      category: "רכב נוסעים",
      route: "/enduser/calculator/m1-petrol-diesel",
    },
    {
      id: "n1-electric",
      title: "רכב פרטי טנדר חשמלי N1",
      description: "חישוב מיסים עבור רכב משא קל חשמלי המיובא באופן אישי",
      // icon: (
      //   <div className="flex items-center">
      //     <svg
      //       className="w-7 h-7 text-blue-600"
      //       fill="none"
      //       stroke="currentColor"
      //       viewBox="0 0 100 100"
      //       strokeWidth="2.5"
      //     >
      //       <path
      //         d="M15 30 L15 60 L35 60 L35 50 L40 45 L40 30 L25 20 L15 30 Z"
      //         strokeLinejoin="round"
      //       />
      //       <path d="M18 45 L32 45 L30 25 L20 25 Z" strokeLinejoin="round" />
      //       <rect x="40" y="40" width="35" height="20" strokeLinejoin="round" />
      //       <circle cx="25" cy="60" r="6" strokeWidth="2.5" />
      //       <circle cx="65" cy="60" r="6" strokeWidth="2.5" />
      //       <line x1="10" y1="60" x2="80" y2="60" strokeWidth="3" />
      //     </svg>
      //     <span className="text-sm text-yellow-500 ml-1">⚡</span>
      //   </div>
      // ),
      icon: (
        <img
          src={N1ElectricPickupIcon}
          alt="טנדר חשמלי N1"
          className="w-12 h-12 object-contain"
        />
      ),
      category: "רכב משא",
      route: "/enduser/calculator/n1-electric",
    },
    {
      id: "regular-truck",
      title: "רכב פרטי טנדר N1 מונע במנוע בנזין, דיזל, היברידי, פלאג אין",
      description: "חישוב מיסים עבור רכב משא קל (בנזין/דיזל) המיובא באופן אישי",
      // icon: (
      //   <svg
      //     className="w-8 h-8 text-blue-600"
      //     fill="none"
      //     stroke="currentColor"
      //     viewBox="0 0 100 100"
      //     strokeWidth="2.5"
      //   >
      //     <path
      //       d="M15 30 L15 60 L35 60 L35 50 L40 45 L40 30 L25 20 L15 30 Z"
      //       strokeLinejoin="round"
      //     />
      //     <path d="M18 45 L32 45 L30 25 L20 25 Z" strokeLinejoin="round" />
      //     <rect x="40" y="40" width="35" height="20" strokeLinejoin="round" />
      //     <circle cx="25" cy="60" r="6" strokeWidth="2.5" />
      //     <circle cx="65" cy="60" r="6" strokeWidth="2.5" />
      //     <line x1="10" y1="60" x2="80" y2="60" strokeWidth="3" />
      //   </svg>
      // ),
      icon: (
        <img
          src={N1TenderPickupIcon}
          alt="טנדר N1"
          className="w-12 h-12 object-contain"
        />
      ),
      category: "רכב משא",
      route: "/enduser/calculator/n1-tender",
    },
    {
      id: "m1-electric",
      title: "רכב פרטי חשמלי M1",
      description:
        "חישוב מיסים עבור רכב נוסעים חשמלי מקבוצת M1 המיובא באופן אישי",
      // icon: (
      //   <div className="flex items-center">
      //     <svg
      //       className="w-7 h-7 text-blue-600"
      //       fill="none"
      //       stroke="currentColor"
      //       viewBox="0 0 100 100"
      //       strokeWidth="2.5"
      //     >
      //       <path
      //         d="M20 60 L20 55 L25 45 L35 35 L65 35 L75 45 L80 55 L80 60"
      //         strokeLinejoin="round"
      //       />
      //       <path d="M30 45 L35 35 L65 35 L70 45" strokeLinejoin="round" />
      //       <line x1="50" y1="35" x2="50" y2="45" />
      //       <circle cx="30" cy="60" r="6" strokeWidth="2.5" />
      //       <circle cx="70" cy="60" r="6" strokeWidth="2.5" />
      //       <line x1="15" y1="60" x2="85" y2="60" strokeWidth="3" />
      //     </svg>
      //     <span className="text-sm text-yellow-500 ml-1">⚡</span>
      //   </div>
      // ),
      icon: (
        <img
          src={M1ElectricCarIcon}
          alt="רכב חשמלי M1"
          className="w-12 h-12 object-contain"
        />
      ),
      category: "רכב נוסעים",
      route: "/enduser/calculator/m1-electric",
    },
    {
      id: "taxi",
      title: "מונית עד 8+1 נוסעים",
      description:
        "חישוב מיסים עבור מוניות עם מס קניה מיוחד 8% (במקום 83%). תמיכה מלאה ב-7 סוגי מנועים וציון ירוק",
      icon: (
  <img src={TaxiIcon} alt="מונית" className="w-12 h-12 object-contain" />
),
      category: "רכב פרטי",
      route: "/enduser/calculator/taxi",
    },

    {
      id: "jet-ski",
      title: "אופנוע ים",
      description: "חישוב מיסים עבור אופנוע ים (ג'ט סקי) המיובא באופן אישי",
      // icon: (
      //   <svg
      //     className="w-8 h-8 text-blue-600"
      //     fill="none"
      //     stroke="currentColor"
      //     viewBox="0 0 100 100"
      //     strokeWidth="2.5"
      //   >
      //     <path
      //       d="M20 50 L30 40 L70 40 L80 50 L75 60 L25 60 Z"
      //       strokeLinejoin="round"
      //     />
      //     <path d="M35 40 L35 30 L65 30 L65 40" strokeLinejoin="round" />
      //     <line x1="50" y1="30" x2="50" y2="40" />
      //     <path d="M20 60 L15 70 L85 70 L80 60" strokeLinejoin="round" />
      //     <line x1="30" y1="50" x2="70" y2="50" />
      //   </svg>
      // ),
      icon: (
        <img
          src={JetSkiIcon}
          alt="אופנוע ים"
          className="w-12 h-12 object-contain"
        />
      ),
      category: "כלי שיט",
      route: "/enduser/calculator/jet-ski",
    },
    {
      id: "collector-vehicle",
      title: "רכב/אופנוע אספנות",
      description:
        "חישוב מיסים עבור רכב או אופנוע אספנות עתיק המיובא באופן אישי",
      // icon: (
      //   <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 100 100" strokeWidth="2.5">
      //     <path d="M25 55 L25 50 L30 40 L35 30 L65 30 L70 40 L75 50 L75 55" strokeLinejoin="round" />
      //     <path d="M35 40 L35 30 L65 30 L65 40" strokeLinejoin="round" />
      //     <circle cx="35" cy="55" r="8" strokeWidth="2.5" />
      //     <circle cx="65" cy="55" r="8" strokeWidth="2.5" />
      //     <line x1="20" y1="55" x2="80" y2="55" strokeWidth="3" />
      //     {/* פנסים עתיקים */}
      //     <circle cx="20" cy="45" r="3" strokeWidth="2" />
      //     <circle cx="80" cy="45" r="3" strokeWidth="2" />
      //     {/* גריל קלאסי */}
      //     <line x1="30" y1="50" x2="70" y2="50" strokeWidth="1" />
      //     <line x1="30" y1="52" x2="70" y2="52" strokeWidth="1" />
      //   </svg>
      // ),
      icon: (
        <img src={CollectorCarIcon} alt="רכב אספנות" className="w-12 h-12" />
      ),
      category: "אספנות",
      route: "/enduser/calculator/collector-vehicle",
    },
    {
      id: "motorcycle",
      title: "אופנועים",
      description: "חישוב מיסים עבור אופנועים רגילים המיובאים באופן אישי",
      // icon: (
      //   <svg
      //     className="w-8 h-8 text-blue-600"
      //     fill="none"
      //     stroke="currentColor"
      //     viewBox="0 0 100 100"
      //     strokeWidth="2.5"
      //   >
      //     <circle cx="25" cy="65" r="12" strokeWidth="2.5" />
      //     <circle cx="75" cy="65" r="12" strokeWidth="2.5" />
      //     <path d="M37 65 L63 65" strokeLinejoin="round" />
      //     <path d="M45 65 L45 45 L55 35 L60 35" strokeLinejoin="round" />
      //     <path d="M40 50 L50 40 L60 40" strokeLinejoin="round" />
      //     <circle cx="50" cy="30" r="4" strokeWidth="2" />
      //     <path d="M50 45 L55 50 L65 50" strokeLinejoin="round" />
      //   </svg>
      // ),
      icon: (
        <img
          src={MotorcycleIcon}
          alt="אופנוע"
          className="w-12 h-12 object-contain"
        />
      ),
      category: "אופנועים",
      route: "/enduser/calculator/motorcycle",
    },
  ];

  const getCategoryColor = (category: string): string => {
    switch (category) {
      case "רכב נוסעים":
        return "bg-blue-50 border-blue-200 text-blue-800";
      case "רכב משא":
        return "bg-green-50 border-green-200 text-green-800";
      case "רכב מסחרי":
        return "bg-yellow-50 border-yellow-200 text-yellow-800";
      case "כלי שיט":
        return "bg-cyan-50 border-cyan-200 text-cyan-800";
      case "אספנות":
        return "bg-purple-50 border-purple-200 text-purple-800";
      case "אופנועים":
        return "bg-orange-50 border-orange-200 text-orange-800";
      case "נגררים":
        return "bg-indigo-50 border-indigo-200 text-indigo-800";
      default:
        return "bg-gray-50 border-gray-200 text-gray-800";
    }
  };

  return (
    <div
      className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8"
      dir="rtl"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header - הסרתי "מחשבוני" */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-2">
  <img src={M1PetrolDieselCarIcon} alt="" className="h-[1em] w-auto inline-block" />
  ייבוא אישי
</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            בחר את סוג הרכב שאתה מעוניין לייבא. כל כלי מותאם לדרישות הספציפיות
            של אותו סוג רכב.
          </p>
        </div>

        {/* Calculators Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {calculators.map((calculator) => (
            <Link
              key={calculator.id}
              to={calculator.route}
              className={`group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden ${getHoverClass(
                "hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              )}`}
            >
              {/* Calculator Card */}
              <div className="p-6">
                {/* Icon and Category */}
                <div className="flex items-center justify-between mb-4">
                  <div className="text-4xl">{calculator.icon}</div>
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium border ${getCategoryColor(
                      calculator.category
                    )}`}
                  >
                    {calculator.category}
                  </span>
                </div>

                {/* Title */}
                <h2
                  className={`text-xl font-bold text-gray-900 mb-3 ${getHoverClass(
                    "group-hover:text-blue-600 transition-colors"
                  )}`}
                >
                  {calculator.title}
                </h2>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {calculator.description}
                </p>

                {/* Action Button */}
                <div className="flex items-center justify-between">
                  <span
                    className={`text-blue-600 font-medium text-sm ${getHoverClass(
                      "group-hover:text-blue-700 transition-colors"
                    )}`}
                  >
                    התחל חישוב
                  </span>
                  <div
                    className={`text-blue-600 ${getHoverClass(
                      "group-hover:text-blue-700 transition-colors"
                    )}`}
                  >
                    <svg
                      className={`w-5 h-5 ${getAnimationClass(
                        "transform group-hover:translate-x-1 transition-transform"
                      )}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Hover Effect Bar - מופיע רק אם אנימציות מותרות */}
              {shouldAnimate && (
                <div className="h-1 bg-gradient-to-r from-blue-500 to-blue-600 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-right"></div>
              )}
            </Link>
          ))}
        </div>

        {/* Info Section */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              ℹ️ מידע חשוב על ייבוא אישי
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div
                className={`bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 ${getHoverClass(
                  "hover:bg-blue-200 transition-colors"
                )}`}
              >
                <span className="text-2xl">📋</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">הכנה נכונה</h3>
              <p className="text-sm text-gray-600">
                ודא שיש ברשותך את כל המסמכים הנדרשים לפני תחילת החישוב
              </p>
            </div>

            <div className="text-center">
              <div
                className={`bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 ${getHoverClass(
                  "hover:bg-green-200 transition-colors"
                )}`}
              >
                <span className="text-2xl">💰</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">חישוב מדויק</h3>
              <p className="text-sm text-gray-600">
                הכלים שלנו מעודכנים לפי התעריפים האחרונים של המכס
              </p>
            </div>

            <div className="text-center">
              <div
                className={`bg-yellow-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 ${getHoverClass(
                  "hover:bg-yellow-200 transition-colors"
                )}`}
              >
                <span className="text-2xl">💾</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">
                אפשרות שמירת חישובים
              </h3>
              <p className="text-sm text-gray-600">
                כל החישובים נשמרים באזור האישי שלך לעיון עתידי
              </p>
            </div>
          </div>
        </div>

        {/* Back to Dashboard */}
        <div className="mt-12 text-center">
          <Link
            to="/enduser/dashboard"
            className={`inline-flex items-center px-6 py-3 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 ${getHoverClass(
              "hover:bg-gray-50 transition-colors"
            )}`}
          >
            <svg
              className="w-4 h-4 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            חזרה לדשבורד
          </Link>
        </div>

        {/* Footer Links */}
        <div className="text-center mt-8 pt-6 border-t border-gray-200">
          <div className="flex justify-center gap-6 text-sm text-gray-500">
            <Link
              to="/terms-and-privacy"
              className="hover:text-blue-600 transition-colors"
            >
              תנאי שימוש ופרטיות
            </Link>
            <span>|</span>
            <Link
              to="/accessibility-statement"
              className="hover:text-blue-600 transition-colors"
            >
              הצהרת נגישות
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalImportCalculatorsPage;